module.exports = __webpack_public_path__ + "static/media/add.275f6ead.svg";